import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ContactUs from '../../components/ContactUs/ContactUs';
import usePageTitle from '../../utils/usePageTitle';

const ContactUsPage = () => {
  usePageTitle('Contact Us');
  const navigate = useNavigate();
  const [open, setOpen] = useState(true);

  const handleClose = () => {
    setOpen(false);
    navigate(-1); // Go back to previous page
  };

  return <ContactUs open={open} onClose={handleClose} />;
};

export default ContactUsPage;